/** Terse builders over the closed kit schema vocabulary for module configs. */
import type { ConfigSchema } from '../schema.js';

export const num = (min: number, max: number): ConfigSchema => ({ type: 'number', min, max });
export const int = (min: number, max: number): ConfigSchema => ({ type: 'number', min, max, integer: true });
export const bool = (): ConfigSchema => ({ type: 'boolean' });
export const oneOf = (...values: string[]): ConfigSchema => ({ type: 'string', maxLength: 40, values });
export const id = (): ConfigSchema => ({ type: 'string', maxLength: 40, pattern: 'id' });
export const list = (items: ConfigSchema, maxItems: number, minItems = 0): ConfigSchema => ({ type: 'array', items, maxItems, minItems });
/** A string field naming a signal kind the module reacts to (`ctx.signals(config.x)`):
 * the game's admission checks some module of the game raises it. */
export const readsSignal = (schema: ConfigSchema = id()): ConfigSchema => signalField(schema, 'reads');
/** A string field naming a signal kind the module raises (`ctx.signal(config.x, …)`). */
export const raisesSignal = (schema: ConfigSchema = id()): ConfigSchema => signalField(schema, 'raises');
function signalField(schema: ConfigSchema, signal: 'reads' | 'raises'): ConfigSchema {
  if (schema.type !== 'string') throw new TypeError('a signal field is a string');
  return { ...schema, signal };
}
/** Object schema; every key not listed in `optional` is required. */
export const obj = (properties: Record<string, ConfigSchema>, optional: readonly string[] = []): ConfigSchema =>
  ({ type: 'object', properties, required: Object.keys(properties).filter(k => !optional.includes(k)) });
